import { jsx as _jsx } from "react/jsx-runtime";
import classNames from "../../../helpers/classNames";
import DraggableBox from "../DraggableBox";
const DraggableGridItem = ({ item: { id, children, props }, elementId, ...rest }) => {
    return (_jsx("div", { "editor-key": id, "editor-has-childs": (children?.length > 0).toString(), className: classNames(!props?.text && !children?.length ? "editor-empty-element" : "", props?.className), ...rest, children: _jsx(DraggableBox, { itemId: id, elementId: elementId, childs: children || [], itemProps: props }) }));
};
export default DraggableGridItem;
//# sourceMappingURL=DraggableGridItem.js.map